import React, { memo } from 'react';
import LaunchIcon from '@material-ui/icons/Launch';
import PropTypes from 'prop-types';

import logo from './logo.svg';

import {
  Wrapper,
  Container,
  Title,
  Content,
  CantLoad,
  Status,
  Button,
} from './ErrorPage.styled';

const ErrorPage = ({ error }) => {
  const forceRefresh = () => {
    window.location.reload();
  };

  const { response: { status } = {} } = error || {};

  const content =
    status === 451 ? (
      <>
        <div>This service is only accessible within the United Kingdom.</div>
        <div>
          It looks like you&apos;re trying to access it from a location outside
          the permitted region.
        </div>
      </>
    ) : (
      <>
        <div> Couldn&apos;t load Aula. Please try again in a few minutes.</div>
      </>
    );

  return (
    <Wrapper data-testid="error-page">
      <Container>
        <img src={logo} alt="Aula" />
        <Title>Something went wrong</Title>
        <Content>
          <CantLoad>
            {content}
            <br />
            You can also check{' '}
            <Status href="https://aulaeducation.statuspage.io/" target="_blank">
              Aula’s status here <LaunchIcon />
            </Status>
          </CantLoad>
          <Button onClick={forceRefresh}>Retry to load</Button>
        </Content>
      </Container>
    </Wrapper>
  );
};

export default memo(ErrorPage);

ErrorPage.propTypes = {
  error: PropTypes.shape({
    response: PropTypes.shape({
      status: PropTypes.number,
    }),
  }),
};

ErrorPage.defaultProps = {
  error: null,
};
